.drawerDivider {
  margin: 0;
}

.inViewFlex {
  display: flex;
  flex-direction: column;
}

.checkoutAccordionItem {
  padding: 20px 40px;

  @media (--reefer-media-tablet-min) {
    padding: 24px;
  }
}

div:has(> .fulfillmentAccordionContent) {
  overflow: visible;
}

.fulfillmentField {
  margin-left: 40px;

  @media (--reefer-media-tablet-min) {
    margin-left: 0;
  }
}
